import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItem, Message, ConfirmationService } from 'primeng/primeng';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng-lts/api';
import { DistriCommandeService } from 'src/app/provider/distri/distri.commande.service';
import { DistriAuthService } from 'src/app/provider/distri/distri.auth.service';
import { DistriAgentService } from 'src/app/provider/distri/distri.agent.service';
import { DistriStoreService } from 'src/app/provider/distri/distri.store.service';
import { DistriUtils } from 'src/app/model/distri/DistriUtils';
import { ConstService } from 'src/app/const.service';

@Component({
  selector: 'app-distri-validate-commande',
  templateUrl: './distri-validate-commande.component.html',
  styleUrls: ['./distri-validate-commande.component.css']
})
export class DistriValidateCommandeComponent  implements OnInit  {

  droit : boolean = true;
  droitValidation : boolean = true;
  titre = 'Détails commande';
  commande: any;
  displayCategorie: boolean;
  displayNafama: boolean;
  typeCommande: string;
  colorFieldset = 'primary';
  colorPanel = 'primary';
  profil = 'adv';
  itemPaiements: any[] = [];
  itemDepots: any[] = [];
  listBanque: SelectItem[] = [];
  listModeReglement: SelectItem[] = [];
  listProduits: SelectItem[] = [];
  today: any = new Date();
  commandeForm: FormGroup;
  msgs: Message[] = [];
  uploadedFiles: any[] = [];
  categoriePiece: string;
  readOnlyOracle: any;
  readOnlyOracleCompta: any;
  referenceOracle: string;
  zoneLivraison: string;
  commentaire: string;
  produitOracle: any = [];
  listProduitOracle: any = [];
  listZone: SelectItem[] = [];
  sommeTotalProduit = 0;
  sommeTotalProduitOracle = 0;
  displaychargement = true;
  displayDialogDepot : boolean;
  idTransactionDepot : string;
  idItem : any;

  displayDialogProduit : boolean;
  debutSerie : string;
  finSerie : string;
  allSerie : string;

  //@ViewChild(ImageComponent, { static: false }) image: ImageComponent;
  images = [];

  @ViewChild('inputimage', { static: false }) inputimage;
  piecesJointes="";
  displayDialogValidate : boolean;
  
  constructor(
    public constService: ConstService, 
    private messageService: MessageService,
    private activatedRoute: ActivatedRoute,
    private store: DistriStoreService,
    private formBuilder: FormBuilder,
    private commandeService: DistriCommandeService,
    private route: Router,
    public authService: DistriAuthService,
    private agentService: DistriAgentService,
    private confirmationService: ConfirmationService
  ) { }

  async ngOnInit() {
    // this.droit = this.constService.hasDroit("DS007") || this.constService.hasDroit("DS002");
    // this.droitValidation = this.constService.hasDroit("DS002") ;
    //console.log('commandeService.disableValidButton: ', this.commandeService.canValidButton);
    this.activatedRoute.queryParamMap.subscribe(async (params) => {
      const id = params.get('id');
      if (!id) {
        return window.history.back();
      }
      console.log('id: ', id);
      await this.loadCommande(id);
    });

    await this.getListZone();
    
  }

  private async loadCommande(id: any) {
    try {
      this.commande = await this.commandeService.commande(id).toPromise();
      console.log('commande: ************' , this.commande);
      if(this.commande === null || this.commande === undefined) {
        this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'error', summary: 'Erreur', detail: 'Commande introuvable en base' });
        return;
      }
      //this.sommeTotalProduit = this.commande.listProduit.length === 0 ? 0 : this.commande.listProduit.map(e => this.commande.typeCommande.toLowerCase() === 'produits' ? e.montant * e.quantite : e.montant).reduce((t, e) => t + e);
      this.sommeTotalProduit = this.commande.listProduit.length === 0 ? 0 : this.commande.listProduit.map(e => e.montant * e.quantite ).reduce((t, e) => t + e);
      console.log('this.commande.piecesJointes: ', this.commande.piecesJointes);
      console.log('this.printFileName: ', this.printFileName(this.commande.piecesJointes));

      this.inputimage.clearFileNames();
      this.inputimage.addFileNames(this.printFileName(this.commande.piecesJointes));

      console.log(this.constService.currentRoleDistri+"====this.commande.etat==="+this.commande.etat);
      this.displayDialogValidate=false;
      //if(this.commande.etat === this.constService.currentRoleDistri) {
      if(this.commande.etatLivraison === 'ENCOURS' && this.commande.etat === this.constService.currentRoleDistri) {
        this.displayDialogValidate=true;
      }

      // this.image.clearFileNames();
      // this.image.addFileNames(this.printFileName(this.commande.piecesJointes));
      //this.images = this.printFileName(this.commande.piecesJointes).split(';').map(e => DistriUtils.newGalleryImage(e));
      //if(this.commande.piecesJointes !== null && this.commande.piecesJointes !== undefined && this.commande.piecesJointes !== "") {
        
        
      //}
      console.log('image:', this.images);
    } catch (error) {

    } finally {
      this.displaychargement=false
    }
  }


  retour() {
    this.displayCategorie = true;
    this.displayNafama = false;
  }

  async loadOracle() {
    this.displaychargement = true;
    try {
      this.produitOracle = await this.commandeService.getOracleData(this.referenceOracle).toPromise();
      console.log('oracles**********: ', this.produitOracle);
      this.sommeTotalProduitOracle = this.listProduitOracle.length === 0 ? 0 : this.listProduitOracle.map(e => e.fulfield_quantity * e.unit_selling_pricing).reduce((t, e) => t + e);
    } catch (error) {

    } finally {
      this.displaychargement = false;
    }
  }


  async chargerOracle(role: string) {
    let reference: any;
    if (role === 'ADV') {
      reference = this.commande.referenceOracle;
    } else {
      reference = this.commande.referenceOracleCompta;
    }
    this.displaychargement = true;
    try {
      this.listProduitOracle = await this.commandeService.getOracleData(reference).toPromise();
      console.log('oracles**********: ', this.listProduitOracle);
      this.sommeTotalProduitOracle = this.listProduitOracle.length === 0 ? 0 : this.listProduitOracle.map(e => e.fulfield_quantity * e.unit_selling_pricing).reduce((t, e) => t + e);
    } catch (error) {

    } finally {
      this.displaychargement = false;
    }

  }

  async validerCommande() {
    console.log("this.commande.listProduit====",this.commande.listProduit);
    if (this.commentaire == null || this.commentaire === undefined || this.commentaire === '') {
      this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'info', summary: 'Confirmation', detail: 'Le commentaire est obligatoire !!!' });
      return;
    }
    if (this.constService.currentRoleDistri === 'MAGASIN') {
      for(let el of this.commande.listProduit){
        if(el.categorie==='PRODUIT' && (el.series == null || el.series === undefined || el.series === '') ){
          this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'info', summary: 'Confirmation', detail: 'Le numéros de series du produit '+el.libelle+' est obligatoire !!!' });
          return;
        }
      }
    }
    this.validerCommandeWithConfirmation('Voulez-vous valider cette commande ?');
  }


  validerCommandeWithConfirmation(message: any) {
    this.confirmationService.confirm({
      message: message,
      accept: async () => {
        this.displaychargement = true;
        try {
          await this.commandeService.next(
            this.commande.id,
            {
              pieces: this.uploadedFiles,
              commentaire: this.commentaire,
              referenceOracle: this.referenceOracle,
              zone: this.zoneLivraison
            })
            .toPromise();
          this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'info', summary: 'Confirmation', detail: 'Traitement effectué avec succès' });
          setTimeout(()=>{
            console.log('waiting');
          this.route.navigateByUrl('/distri/list-commande');
          }, 100);
        } catch (error) {

        } finally {
          this.displaychargement = false;
        }
      }
    });
  }

  rejetCommandeWithConfirmation(message: any) {
    this.confirmationService.confirm({
      message: message,
      accept: async () => {
        this.displaychargement = true;
        try {
          await this.commandeService.previous(this.commande.id,
            { pieces: this.uploadedFiles, commentaire: this.commentaire, referenceOracle: this.referenceOracle }
          ).toPromise();
          this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'info', summary: 'Confirmation', detail: 'Traitement effectué avec succès' });
          setTimeout(()=>{
            console.log('waiting');
            this.route.navigateByUrl('/distri/list-commande');
          }, 100);
        } catch (error) {

        } finally {
          this.displaychargement = false;
        }
      }
    });
  }

  async rejeterCommande() {
    if (this.commentaire == null || this.commentaire === undefined || this.commentaire === '') {
      this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'info', summary: 'Confirmation', detail: 'Le commentaire est obligatoire !!!' });
      return;
    }
    this.rejetCommandeWithConfirmation('Voulez-vous rejeter cette commande ?');
  }

  async UpdateCommande() {
    if (this.commentaire == null || this.commentaire === undefined || this.commentaire === '') {
      this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'info', summary: 'Confirmation', detail: 'Le commentaire est obligatoire !!!' });
      return;
    }
    this.displaychargement = true;
    try {
      await this.commandeService.update(
        this.commande.id,
        {
          commentaire: this.commentaire,
        })
        .toPromise();
      this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'info', summary: 'Confirmation', detail: 'Traitement effectué avec succès' });
      this.route.navigateByUrl('/root/list-commande');
    } catch (error) {

    } finally {
      this.displaychargement = false;
    }
  }

  async getListZone() {
    console.log('getListZone: ', this.listZone);
    this.listZone = [
      { label: 'ZONE...', value: null },
      ...(await this.agentService.findAllZone().toPromise() as any).map(element => {
        return {
          label: element.nom, value: element.nom
        };
      })];
    console.log('listZone: ', this.listZone);
  }

  initForm() {
    this.commandeForm = this.formBuilder.group({
      referenceOracle: [this.commande && this.commande.referenceOracle, [Validators.required]],
    });
  }
  actualiser() {
    this.ngOnInit();
  }

  exportCharges() {
  }

  printFileName2(names: string): string {
    const images = names.split(';').filter(e => e).map(a => a + '.jpg').join(';');
    console.log('images::', images);
    return images;
  }
  printFileName(names: string): string {
    if (names === null || names === undefined || names === "") {
        return "";
    }
    let images: string[] = names.split(";");
    if (images.length < 1) {
        return "";
    }
    let val = "";
    for (var i = 0; i < images.length; i++) {
        if (images[i] !== "") {
            val = val + images[i] + ".jpg;";
        }
    }
    return val;
}

  async detectFiles0(event) {
    console.log('files: ', event.target.files);
    const files = [];
    for (let i = 0; i < event.target.files.length; i++) {
      files.push(event.target.files[i]);
    }
    await Promise.all(files.map(async file => {
      try {
        const filesNames = (await this.commandeService.sendToOpenStack(file, files.indexOf(file)).toPromise() as any);
        console.log('filesNames: ', filesNames);
        filesNames.forEach(async (element: any) => {
          this.uploadedFiles.push({
            nom: element,
            categorie: this.categoriePiece,
            agent: this.authService.currentUser.login,
            profil: this.constService.currentRoleDistri
          });
        });
      } catch (error) {
      }
    }));
    console.log('uploadedFiles: ', this.uploadedFiles);

    console.log('uploadedFiles: ', this.uploadedFiles);
    this.piecesJointes = '';
    this.uploadedFiles.forEach(e => {
      this.piecesJointes = this.piecesJointes + e.nom + ';';
    });
    console.log('piecesJointes: ', this.piecesJointes);
    console.log('this.printFileName(this.piecesJointes): ', this.printFileName(this.piecesJointes));

    this.inputimage.clearFileNames();
    this.inputimage.addFileNames(this.printFileName(this.piecesJointes + this.commande.piecesJointes));

  }

  editElementTransaction(cat) {
    this.displayDialogDepot = true;
    this.idTransactionDepot = "";
    this.debutSerie = "";
    this.finSerie = "";
    this.allSerie = "";
    this.idItem = cat.id;
  }
  editElementProduit(cat) {
    this.displayDialogProduit = true;
    this.idTransactionDepot = "";
    this.debutSerie = "";
    this.finSerie = "";
    this.allSerie = "";
    this.idItem = cat.id;
  }

  async saveTransaction() {
    // Appeler service de save
    if(this.idTransactionDepot === '' || this.idTransactionDepot === null || this.idTransactionDepot=== undefined){
      this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'error', summary: 'Confirmation', detail: 'Merci de renseigner l\' ID TRANSACATION' });
      return;
    }
    this.displaychargement = true;
    try {
      await this.commandeService.saveDetail(this.idItem, this.idTransactionDepot)
        .toPromise();
      this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'info', summary: 'Confirmation', detail: 'Traitement effectué avec succès' });
      this.displayDialogDepot = false;
      this.actualiser();
    } catch (error) {
      console.log(error);
    } finally {
      this.displaychargement = false;
    }
  }

  async saveProduit() {
    // Appeler service de save
    /*
    if(this.debutSerie === '' || this.debutSerie === null || this.debutSerie=== undefined){
      this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'error', summary: 'Confirmation', detail: 'Merci de renseigner le début de serie' });
      return;
    }
    if(this.finSerie === '' || this.finSerie === null || this.finSerie=== undefined){
      this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'error', summary: 'Confirmation', detail: 'Merci de renseigner la fin de serie' });
      return;
    }
    */
    if(this.allSerie === '' || this.allSerie === null || this.allSerie=== undefined){
      this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'error', summary: 'Confirmation', detail: 'Merci de renseigner les series' });
      return;
    }
    this.displaychargement = true;
    try {
      await this.commandeService.saveDetailSerie(this.idItem, this.debutSerie, this.finSerie, this.allSerie).toPromise();
      this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'info', summary: 'Confirmation', detail: 'Traitement effectué avec succès' });
      this.displayDialogProduit = false;
      this.actualiser();
    } catch (error) {
      console.log(error);
    } finally {
      this.displaychargement = false;
    }
  }

}
